import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { TipoDeMensajeSwal } from 'src/app/models/enums/tipo-de-mensaje-swal';
import { AuthService } from 'src/app/services/auth.service';
import { HttpGenericService } from 'src/app/services/http-generic.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  usuario: string;
  contrasena: string;
  procesando: boolean = false;
  queryParams: any;

  constructor(
    private route: ActivatedRoute,
    private swal: SweetAlertService,
    private auth: AuthService,
    private http: HttpGenericService,
    private router: Router) { }

  ngOnInit() {
    this.route.queryParams.subscribe(c => this.queryParams = c);
    this.auth.cerrarSesion();
  }

  iniciarSesion() {
    this.procesando = true;
    this.http.login(this.usuario, this.contrasena)
      .then(data => {
        this.auth.crearSesion(data);
        this.auth.estaLogueado.next(true);
        if(this.queryParams.module == 'system') {
          this.router.navigate(['/admin/proveedores']);
        }
        else {
          this.router.navigate(['/proveedores/inscription']);
        }
      }).catch(err => {
        this.procesando = false;
        if(err.status === 401) {
          this.swal.mostrar(TipoDeMensajeSwal.Error, 'Datos de acceso incorrectos', '');
        }
      });
  }

}
